<template>
  <v-card :width="width" :class="`py-0 ${withPaddings ? cardClass : ''}`" :elevation="0">
    <v-card-title
      v-if="showClose !== false && ($vuetify.breakpoint.smAndDown || showClose)"
      class="px-0 py-0"
      :class="{ 'px-4 px-md-10': withPaddings }"
    >
      <DialogHeader :show-close="true" :show-back-arrow="false" @close="$emit('close')">
        <template v-if="headerIcon" #leftIcon>
          <v-img contain width="56" height="56" :src="$asset(`img/icons/${headerIcon}.svg`)" />
        </template>
        <template v-if="titleAsHeader" #default>
          {{ title }}
        </template>
      </DialogHeader>
    </v-card-title>
    <v-card-text
      v-if="perex || hasBodySlot || (title && !titleAsHeader)"
      class="pa-0 d-flex d-md-block flex-column justify-start"
      :class="{
        'px-4 px-md-10': withPaddings,
        'pb-6': hasActionSlot
      }"
    >
      <div class="d-flex flex-column align-start">
        <v-img
          v-if="icon"
          width="56"
          height="56"
          class="mb-6 col-auto"
          :src="$asset(`img/icons/${icon}.svg`)"
        />
        <div v-else-if="$slots.icon" class="mb-6">
          <slot name="icon" />
        </div>
        <h6
          v-if="title && !titleAsHeader"
          :class="{
            'mb-4': perex && perex.length,
            'mb-6': !(perex && perex.length) && hasBodySlot
          }"
          v-html="title"
        />
      </div>
      <div v-if="perex && perex.length" :class="{ 'mb-6': hasActionSlot }" v-html="perex" />
      <div v-if="hasBodySlot" :class="{ 'mb-6': hasActionSlot }">
        <slot name="body" />
      </div>
    </v-card-text>
    <v-card-actions
      v-if="hasActionSlot"
      class="pa-0 mt-0"
      :class="{
        'px-4 px-md-10': withPaddings,
        'no-border': noActionBorder
      }"
    >
      <slot name="action" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'InfoMessage',
  props: {
    title: {
      type: String,
      required: false
    },
    titleAsHeader: {
      type: Boolean,
      default: false
    },
    perex: {
      type: String,
      default: null
    },
    typeMessage: {
      type: String,
      default: 'success'
    },
    headerIcon: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      default: null
    },
    width: {
      type: [Number, String],
      required: false
    },
    withPaddings: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: null
    },
    cardClass: {
      type: String,
      default: 'py-10'
    },
    noActionBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasActionSlot() {
      return !!this.$slots?.action?.length;
    },
    hasBodySlot() {
      return !!this.$slots?.body?.length;
    }
  }
};
</script>
